import React from "react";
import Booking from "@/components/Booking";

export default function BookPage() {
  return (
    <div className="pt-24" data-testid="page-book">
      <Booking />
    </div>
  );
}
